export default defineNuxtPlugin(() => {
  return {
    provide: {
      utm: useUTM()
    }
  }
})
